import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Refresh} from '@client/refresh'
import {Link} from '@components/common/button/button'
import ExitIcon from './icon-exit.svg'

const TwTitle = tw.div`
  text-main-old
  mb-24
  leading-6
  text-20
  cursor-default
  font-semibold
  pr-16
`

const TwPanel = tw.div`
  p-24
  border-solid
  border-bg-main-old
  bg-main-old
  border
  rounded-md
  flex-1
  relative
  min-w-424
  gap-24
`

export const Panel = ({
  title,
  logout = false,
  children
}: {
  title: string
  logout?: boolean
  children: React.ReactNode
}) => {
  return (
    <TwPanel>
      <TwTitle>{title}</TwTitle>
      {logout && (
        <Link
          className="absolute flex items-center top-24 right-20 text-error-old"
          onClick={() => Refresh.clearCredentials()}
        >
          <div className="flex">
            <ExitIcon />
          </div>
          <div className="w-8"></div>
          <div className="cursor-pointer">{Lang.msg.logoutYouGile}</div>
        </Link>
      )}
      {children}
    </TwPanel>
  )
}
